module.exports = __webpack_public_path__ + "static/img/002.0b90fac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/002.png
// module id = g8vl
// module chunks = 1